import React from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import { ENUM_TYPE_DOWNLOAD } from 'constants/enum';
import AppRoutes from 'routes/routes';
import { setOpenDownload } from 'store/actions/survey';

const SurveyListHeader = ({ options }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const handleItemOverview = () => {
    const from = (options.page - 1) * options.page_size + 1;
    const to = from + options.page_size - 1;
    const total = options.total;

    return `${from} - ${to > total ? total : to} / ${total} ${t('ITEMS')}`;
  };

  const handleOpenDownload = (typeDownload) => {
    dispatch(
      setOpenDownload({
        isOpen: true,
        type: typeDownload,
      })
    );
  };

  return (
    <div className="flex items-end justify-between gap-2 mt-2">
      <p className="text-sm opacity-85 text-gray-336">{handleItemOverview()}</p>
      <div className="flex space-x-4">
        <Button
          onClick={() => handleOpenDownload(ENUM_TYPE_DOWNLOAD.CSV)}
          color="outline"
          text={t('CSV_DOWNLOAD')}
          className="w-55.75 h-9.5 text-sm !px-3.75 !py-1"
          icon={<img src={require('assets/resources/FileSave.svg').default} alt="plus icon" width={14} height={14} />}
        />
        <Button
          onClick={() => handleOpenDownload(ENUM_TYPE_DOWNLOAD.EXCEL)}
          color="outline"
          text={t('EXCEL_DOWNLOAD')}
          className="w-57.25 h-9.5 text-sm !px-3.75 !py-1"
          icon={<img src={require('assets/resources/FileSave.svg').default} alt="plus icon" width={14} height={14} />}
        />
        <Button
          onClick={() => navigator(AppRoutes.surveyCreate)}
          color="primary"
          text={t('CREATE_SURVEY')}
          className="w-40 h-9.5"
          icon={<img src={require('assets/resources/Plus.svg').default} alt="plus icon" width={18} height={18} />}
        />
      </div>
    </div>
  );
};

export default React.memo(SurveyListHeader);
